import { Icon } from "../../Icon";
import { IIcon } from "../../interfaces/IIcon";

export const experienceIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="3"/><path fill="#FFF" fill-rule="nonzero" d="M37.303 41v-3h-6.235v-4.418h5.801v-2.977h-5.8v-3.761h6.234v-2.977h-9.867V41z"/></svg>`
);
